"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cpsCarrierMock = void 0;
const cpsCarrierMock = (carrier) => ({
    id: 'a7e340d0-18e8-48db-b034-c2a06a440a61',
    type: 'CARRIER',
    company_name: 'Test Company',
    email: 'carrier@email.com',
    address: {},
    carrier_manager: 'm1',
    salesforce_id: 'sf1',
    mothership_id: 12345,
    is_denylisted: false,
    vetting_status: 'COMPLETED',
    vat: {
        country_code: 'DE',
        number: '3335526262'
    },
    billing: {
        address: {},
        invoicing_term_days: 30
    },
    fleet_overview: {
        filled: false
    },
    gps_integration: { gps_integrated: true },
    certifications: {},
    ...carrier
});
exports.cpsCarrierMock = cpsCarrierMock;
